import { useState, useEffect, useRef } from "react";
import Keycloak from "keycloak-js";

// const client = new Keycloak({
//     url: "https://keycloak.m-devsecops.com/",
//     realm: "redoms-auth",
//     clientId: "redoms",
// });

const client = new Keycloak({
    url: "http://localhost:8080",
    realm: "ReDoms",
    clientId: "democlient",
});

const useAuth = () => {
    const isRun = useRef(false);
    const [isLogin, setLogin] = useState(false);
    const [token, setToken] = useState(null);
    const [username, setUsername] = useState(null); // Add username state
    const [isLoading, setLoading] = useState(true); // Add a loading state

    useEffect(() => {
        if (isRun.current) return;

        isRun.current = true;
        client.init({
            onLoad: "login-required",
        })
        .then((authenticated) => {
            console.log("Keycloak initialized:", authenticated);
            setLogin(authenticated);
            if (authenticated) {
                setToken(client.token);

                // Retrieve the username from the token
                const userProfile = client.tokenParsed;
                const username = userProfile.preferred_username || userProfile.username;
                setUsername(username);

                // Store the username in sessionStorage
                sessionStorage.setItem("username", username);

                // console.log("Keycloak token:", client.token);
                // console.log("Username:", username);
            }
        })
        .catch((error) => {
            console.log("Keycloak initialization failed:", error);
        })
        .finally(() => {
            setLoading(false); // Set loading to false once initialization is complete
        });
    }, []);

    return { isLogin, token, username, Keycloak: client, isLoading };
};

export { client };
export default useAuth;